const INTERVAL = {
    START_TRADING: 30,
    PLACE_ORDERS: 1.5,
    MARKET_CHECK: 15,
};

export default INTERVAL;
